import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const PadlockUnlocked = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25 16H10V12C10 8.68702 12.688 6.00002 16 6.00002C19.025 6.00002 22 8.47502 22 11C22 11.55 22.45 12 23 12C23.55 12 24 11.55 24 11C24 9.22502 23.075 7.42502 21.475 6.06202C19.925 4.74902 17.925 3.99902 16 3.99902C11.588 3.99902 8 7.58702 8 11.999V15.999H7C5.35 15.999 4 17.349 4 18.999V22.999C4 25.761 6.237 27.999 9 27.999H23C25.762 27.999 28 25.761 28 22.999V18.999C28 17.349 26.65 15.999 25 15.999V16ZM26 23C26 24.65 24.65 26 23 26H9C7.35 26 6 24.65 6 23V19C6 18.45 6.45 18 7 18H25C25.55 18 26 18.45 26 19V23Z" />
		<path d="M18 21C18 20.45 18.45 20 19 20H21C21.55 20 22 20.45 22 21C22 21.55 21.55 22 21 22H19C18.45 22 18 21.55 18 21Z" />
	</svg>
);

export default PadlockUnlocked;
